import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo } from "react";
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import { userApi } from "redux/user/api";
import { BONUS_STATUS, BonusListType } from "types/Bonus";

export const useNotificationUserBonuses = () => {
  const observableStatuses = [
    BONUS_STATUS.ACTIVE,
    BONUS_STATUS.AVAILABLE,
    BONUS_STATUS.QUEUE,
    BONUS_STATUS.AVAILABLE_QUEUE,
    "Active",
    "Available",
    "Queue",
    "Available_queue",
  ];

  const { refetch: bonusRefetch } = userApi.useBonusesQuery("");
  const { refetch: bonusNominalRefetch } = userApi.useBonusNominalQuery("");
  const { refetch: spinRefetch } = userApi.useFreeSpinsQuery("");
  const { refetch: triggersRefetch } = userApi.useAvailableTriggersQuery("");

  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { bonuses, bonusNominal, triggerCompaings, freeSpins } = useSelector(
    userSelectors.all,
  );

  const invalidateBonuses = useCallback(() => {
    if (isAuthenticated) {
      bonusRefetch();
      bonusNominalRefetch();
      spinRefetch();
      triggersRefetch();
    }
  }, [
    isAuthenticated,
    bonusNominalRefetch,
    bonusRefetch,
    spinRefetch,
    triggersRefetch,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      invalidateBonuses();
    }
  }, [
    isAuthenticated,
    bonusRefetch,
    spinRefetch,
    triggersRefetch,
    bonusNominalRefetch,
    invalidateBonuses,
  ]);

  const list = useMemo<BonusListType[]>(
    () => [...bonuses, ...triggerCompaings, ...freeSpins, ...bonusNominal],
    [bonuses, freeSpins, triggerCompaings, bonusNominal],
  );

  return {
    isActive: list.some((bonus) => observableStatuses.includes(bonus.status)),
    invalidateBonuses,
  };
};
